exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na:hover a:hover span[data-v-50714c6d],\ndiv a:hover span[data-v-50714c6d],\na:hover a.router-link-active span[data-v-50714c6d],\ndiv a.router-link-active span[data-v-50714c6d] {\n\tfont-weight: bold;\n}\n.custom div[data-v-50714c6d]:nth-child(odd) {\n\tbackground: #f5f5f5;\n}\n", ""]);

// exports
